export const getKey = (searchString, searchParams) => {
  for (var key of searchParams.keys()) {
    if (searchString.toLowerCase() === key.toLowerCase()) {
      return key;
    }
  }
  return searchString;
};

export const getUrlParam = searchString => {
  const params = new URLSearchParams(window.location.search);
  return params.get(getKey(searchString, params));
};

export function convertUrl(url, order) {
  if (!url || url === 'https://' || url === '123') return '';
  try {
    const newUrl = new URL(url);
    let params = newUrl.search;
    if (/\[badgeno\]|\[clientkey\]/gi.test(params)) {
      if (order && order?.badgeNo) {
        params = params.replace(/\[badgeno\]|\[clientkey\]/gi, order.badgeNo);
      } else {
        params = params.replace(/\[badgeno\]|\[clientkey\]/gi, '').replace(/&?badgeno=|&?clientkey=/gi, '');
      }
      let basicUrl = newUrl.origin + newUrl.pathname + params;
      return basicUrl;
    }
  } catch (err) {
    return url;
  }
  return url;
}
